/* BACK TO OFFICE – countdown i sticky „Dodaj do koszyka”.
   Termin końca oferty ustawiasz w bloku „BTO: Buy box” (atrybut data-bto-deadline). */
(function () {
  if (window.__btoInit) return;
  window.__btoInit = true;

  var timer = null;
  var pad = function (n) { return String(n).padStart(2, '0'); };

  function mainAddButton() {
    return document.querySelector('.product-details .buy-buttons-block button[name="add"]');
  }

  function startCountdown() {
    if (timer) clearInterval(timer);
    var source = document.querySelector('[data-bto-deadline]');
    if (!source) return;
    var deadline = new Date(source.getAttribute('data-bto-deadline')).getTime();
    if (isNaN(deadline)) return;
    var lock = source.hasAttribute('data-bto-lock');
    var endedText = source.getAttribute('data-bto-ended') || 'Oferta zakończona';

    function tick() {
      var diff = Math.max(0, deadline - Date.now());
      var d = Math.floor(diff / 864e5);
      var h = Math.floor(diff / 36e5) % 24;
      var m = Math.floor(diff / 6e4) % 60;
      var s = Math.floor(diff / 1e3) % 60;
      var parts = { d: pad(d), h: pad(h), m: pad(m), s: pad(s) };

      document.querySelectorAll('[data-bto-cd]').forEach(function (el) {
        el.textContent = parts[el.getAttribute('data-bto-cd')];
      });
      var inline = diff ? d + ' dni ' + parts.h + ':' + parts.m + ':' + parts.s : endedText;
      document.querySelectorAll('[data-bto-cd-inline]').forEach(function (el) { el.textContent = inline; });

      if (!diff) {
        document.querySelectorAll('.bto-cd').forEach(function (el) { el.classList.add('is-ended'); });
        document.querySelectorAll('[data-bto-cd-status]').forEach(function (el) { el.textContent = endedText; });
        if (lock) {
          var btn = mainAddButton();
          if (btn) btn.disabled = true;
          document.querySelectorAll('[data-bto-sticky-btn]').forEach(function (b) { b.disabled = true; });
        }
        clearInterval(timer);
      }
    }
    tick();
    timer = setInterval(tick, 1000);
  }

  var observer = null;
  function initSticky() {
    var bar = document.querySelector('[data-bto-sticky]');
    if (!bar) return;
    var stickyBtn = bar.querySelector('[data-bto-sticky-btn]');
    var target = mainAddButton() || document.querySelector('.bto-buy');
    if (!target) return;

    stickyBtn.onclick = function () {
      var btn = mainAddButton();
      if (btn && !btn.disabled) {
        btn.click(); // natywny formularz Horizona: dodaje do koszyka i otwiera szufladę
      } else if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    };

    if (observer) observer.disconnect();
    if (!('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      stickyBtn.tabIndex = show ? 0 : -1;
    });
    observer.observe(target);
  }

  function init() { startCountdown(); initSticky(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
